import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterPlacement, PageFilters } from '../../../core/components/PageFilters';
import useDamageClaimOptions from '../../reclamations/hooks/useDamageClaimOptions';
import { removeReports, setFromDate, setUntilDate } from '../actions';
import DamageAreaReport from '../components/DamageAreaReport';
import MakeModelReport from '../components/MakeModelReport';
import ReportTypeSelector from '../components/ReportTypeSelector';
import { ReportType } from '../models';
import { selectFromDate, selectReportType, selectUntilDate } from '../reducer';

const toFilterDate = (value) => {
  if (!value) return null;
  const date = moment(value);
  return date.isValid() ? date.toDate() : null;
};

export const ClaimReports = () => {
  const dispatch = useDispatch();
  const reportType = useSelector(selectReportType);
  const fromDate = useSelector(selectFromDate);
  const untilDate = useSelector(selectUntilDate);
  useDamageClaimOptions();

  useEffect(() => {
    return function cleanUp() {
      dispatch(removeReports());
    };
  }, []);

  const filterConfigs = useMemo(
    () => [
      {
        id: 'dateRange',
        type: 'dateRange',
        name: 'Date',
        placement: FilterPlacement.Chiclet,
        defaultVisible: true,
        icon: <i className="uil uil-calendar-alt" />,
        startDate: toFilterDate(fromDate),
        endDate: toFilterDate(untilDate),
        native: true,
        onChange: ([startDate, endDate]) => {
          dispatch(setFromDate(startDate ? moment(startDate) : fromDate));
          dispatch(setUntilDate(endDate ? moment(endDate) : untilDate));
        },
      },
    ],
    [dispatch, fromDate, untilDate]
  );

  return (
    <section className="claim-reports">
      <div className="filters-actions-container mb-3">
        <PageFilters filters={filterConfigs} maxChicletFilters={1} />
      </div>
      <ReportTypeSelector />
      {reportType === ReportType.ClaimsByVehicleModel && <MakeModelReport />}
      {reportType === ReportType.ClaimsByDamageArea && <DamageAreaReport />}
    </section>
  );
};

export default ClaimReports;
